import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  get systemPreference() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  set theme(theme) {
    // apply theme to the document
    this.apply(theme);
  }

  get theme() {
    // read the theme preference from the document
    return document.documentElement.dataset.theme;
  }

  connect() {
    // force the current theme to ensure the app state is synced
    if (this.theme === 'system') {
      this.override(this.systemPreference, false);
    } else {
      this.override(this.theme, false);
    }

    // listen for changes to system theme
    this.boundMatchMediaChange = this.matchMediaChange.bind(this);
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', this.boundMatchMediaChange);
  }

  disconnect() {
    window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', this.boundMatchMediaChange);
  }

  async matchMediaChange(event) {
    // bail if the current theme is not system
    if (this.theme !== 'system') return;

    // apply the new system theme
    this.apply(event.matches ? 'dark' : 'light');
  }

  async override(theme, persist = true) {
    // pass the override to electron
    if (window.electron?.available && window.electron.theme) await window.electron.theme.override(theme);

    // persist the new theme
    if (persist) this.theme = theme;

    // apply the new theme directly
    this.apply(theme);
  }

  apply(theme) {
    if (theme === 'system') theme = this.systemPreference;
    document.documentElement.dataset.theme = theme;
  }

  // shortcuts for easier stimulus actions
  async toggle() {
    let theme = this.theme;
    if (theme === 'system') theme = this.systemPreference;
    await this.override(theme === 'dark' ? 'light' : 'dark');
  }

  async system() {
    await this.override('system');
  }

  async dark() {
    await this.override('dark');
  }

  async light() {
    await this.override('light');
  }
}
